// @flow
import SearchResults from './SearchResults';

export default SearchResults;



// WEBPACK FOOTER //
// ./src/components/search/SearchResults/index.js